export const SEARCH_ACCOUNTS = "SEARCH_ACCOUNTS";

export default SEARCH_ACCOUNTS;
